import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { UserService } from 'services';
import Tools from 'utils/Tools';

const filters = 'orderBy=name&order=ASC&forSelect=true';

const WriterSelect = memo(({ formik, multiple }) => {
	const [writers, setWriters] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (isLoading) {
			UserService.getWriters(filters)
				.then(({ data }) => {
					setWriters(data);
				})
				.catch(console.log)
				.finally(() => setIsLoading(false));
		}
	}, [isLoading]);

	return (
		<FormControl fullWidth>
			<InputLabel id="writerId-label">Redactor</InputLabel>
			<Select
				id="writerId"
				label="Cliente"
				labelId="writerId-label"
				multiple={multiple}
				name="writerId"
				onChange={formik.handleChange}
				value={formik.values.writerId}
			>
				{!multiple && <MenuItem value="">- Todos -</MenuItem>}
				{writers.map(({ id, name, lastName }) => (
					<MenuItem key={id} value={id}>
						{Tools.getFullName({ name, lastName })}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
});

export default WriterSelect;
